import { isLocal, isProduction } from "@ctra/utils";

/**
 * Redirect URL for the signup app
 * @type {string}
 */
export const redirectURL = isLocal()
  ? "http://localhost:3001"
  : `https://signup.${isProduction() ? "" : "staging-"}app.connecterra.ai`;
